import { createContext, useContext, useState, ReactNode } from 'react';

type SpinnerContextType = {
  loading: boolean;
  showSpinner: () => void;
  hideSpinner: () => void;
};

const SpinnerContext = createContext<SpinnerContextType | undefined>(undefined);

type SpinnerProviderProps = {
  children: ReactNode;
};

export const SpinnerProvider = ({ children }: SpinnerProviderProps) => {
  const [loading, setLoading] = useState(false);

  const showSpinner = () => setLoading(true);
  const hideSpinner = () => setLoading(false);

  return (
    <SpinnerContext.Provider value={{ loading, showSpinner, hideSpinner }}>
      {children}
    </SpinnerContext.Provider>
  );
};

export const useSpinner = (): SpinnerContextType => {
  const context = useContext(SpinnerContext);
  if (!context) {
    throw new Error('useSpinner must be used within a SpinnerProvider');
  }
  return context;
};
